import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'

interface IProps {
  active: 'calendar' | 'guest_list'
  month: string
  slug: string
}

const PartnerVenueTabs: React.FC<IProps> = ({ active, month, slug }) => {
  const query = `?month=${month}`

  return (
    <Wrapper>
      <a className={active === 'calendar' ? 'active' : ''} href={`/partner_venues/${slug}${query}`}>
        人数照会
      </a>
      <a
        className={active === 'guest_list' ? 'active' : ''}
        href={`/partner_venues/${slug}/guest_list${query}`}
      >
        ゲスト名簿
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border-bottom: 1px solid ${constants.COLORS.divider2};

  a {
    padding: 10px 12px 8px;
    border-bottom: 2px solid transparent;
    color: ${constants.COLORS.subText};
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;

    &.active {
      border-bottom-color: ${constants.COLORS.primary};
      color: ${constants.COLORS.primary};
    }

    @media (min-width: ${constants.BREAKPOINT_TABLET}px) {
      font-size: 14px;
    }
  }
`

export default PartnerVenueTabs
